/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.themes.donation.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.directive.combobox'
])

.controller('ThemesDonationController', [
  '$scope', '$state', '$timeout', '$uibModal',
  'NoticeFactory', 'GridStateFactory', 'GridDefinitionFactory',
  'ApiService', 'HelpersService',
  'DonationData', 'UsersData',
  function(
    $scope, $state, $timeout, $uibModal,
    NoticeFactory, GridStateFactory, GridDefinitionFactory,
    ApiService, HelpersService,
    DonationData, UsersData
  ) {

    $scope.themesDonation = {

      model: [],

      hasThemes: false,

      fiterType: {
        id: 'active',
        name: 'Active'
      },

      fiterTypes: [
        {
          id: 'all',
          name: 'All'
        },
        {
          id: 'active',
          name: 'Active'
        },
        {
          id: 'deactive',
          name: 'Deactivated'
        }
      ],

      notice: new NoticeFactory(),

      users: {},

      // gridDefinition
      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),
      viewId: '',
      gridName: $state.current.name+'.grid0',
      optionsOverride: {
        data: 'themesDonation.model',
        hideHeaderInfo: true,
        enableSorting: false,
        useAccessibleGrid: true,
        columnDefs: [
            {
              field: 'editable',
              displayName: 'Edit',
              width: 60,
              enableHiding: false,
              onCellNavClick: function(row, col) {
                $scope.themesDonation.optionsOverride.appScopeProvider.edit(row.entity);
              },
              cellTemplate: '<div class="ui-grid-cell-contents text-center" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.edit(row.entity)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>'
            },
            {
              field: 'updatedOn',
              displayName: 'Last Modified Date',
              cellFilter: 'date: "' + HelpersService.dateFormats.midDate + '"'
            },
            {
              field: 'name',
              displayName: 'Name'
            },
            {
              field: 'description',
              displayName: 'Description'
            },
            {
              field: 'token',
              displayName: 'Query parameter'
            },
            {
              field: 'id',
              displayName: 'ID',
              visible: false
            },
            {
              field: 'createdByName',
              displayName: 'Created By',
              visible: false,
              cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.gotoUser(row.entity.createdBy)" role="button">{{ row.entity.createdByName }}</a></div>'
            },
            {
              field: 'createdOn',
              displayName: 'Created Date',
              visible: false,
              cellFilter: 'date: "' + HelpersService.dateFormats.midDate + '"'
            },
            {
              field: 'updateByName',
              displayName: 'Last Modified By',
              visible: false,
              cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.gotoUser(row.entity.updateBy)" role="button">{{ row.entity.updateByName }}</a></div>'
            },
            {
              field: 'deactivate',
              displayName: 'Deactivate',
              width: 100,
              enableHiding: false,
              onCellNavClick: function(row, col) {
                $scope.themesDonation.optionsOverride.appScopeProvider.deactivate(row.entity);
              },
              cellTemplate: '<div class="ui-grid-cell-contents text-center" ng-class="col.colIndex()"><a data-ng-if="!row.entity.archived" data-ng-click="grid.appScope.deactivate(row.entity)" role="button">Deactivate<span class="sr-only"> Deactivate {{ row.entity.name }}</span></a></div>'
            }
        ],
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.themesDonation.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDblClick: function (item) {
            $scope.themesDonation.edit(item.entity);
          },
          edit: function (item) {
            $scope.themesDonation.edit(item);
          },
          gotoUser: function (id) {
            $scope.themesDonation.gotoUser(id);
          },
          deactivate: function (item) {
            $scope.themesDonation.deactivate(item);
          }
        },
      },

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Themes'
        });

        this.viewId = $state.current.name;
        this.gridDefinition.init(this.gridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);

        if (DonationData && DonationData.data.payload.list.length) {
          this.hasThemes = true;
        }

        if (UsersData && UsersData.data.payload.list.length) {
          this.proccessUsers();
        }

        this.initWatchersAndEvents();
      },

      initWatchersAndEvents: function() {
        $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));
      },

      initData: function() {
        var self = $scope.themesDonation,
            props = self.gridDefinition.getGridState();

            props.sortField = 'updatedOn';
            props.sortDirection = 'desc';

        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getDonationTheme();
      },

      getDonationTheme: function() {
        var self = $scope.themesDonation,
            archived = false,
            props = Object.assign(self.gridState.getGridState(), { archived: archived });

        if (self.fiterType.id !== 'all') {
          props.archived = self.fiterType.id === 'active' ? 'false' : 'true';
        }

        ApiService.textVariables.override.list(props).then(self.success.getDonationTheme, self.error.getDonationTheme);
      },

      proccessUsers: function() {
        var self = $scope.themesDonation;

        UsersData.data.payload.list.forEach(function(item) {
          self.users[item.id] = item.firstName + ' ' + item.lastName;
        });
      },

      proccess: function(list) {
        var self = $scope.themesDonation;
        return list.map(function(item) {
          item.createdByName = self.users[item.createdBy];
          item.updateByName = self.users[item.updateBy];
          return item;
        });
      },

      edit: function(item) {
        $state.go('application.themes.donationCreate', { id: item.id });
      },

      gotoUser: function(id) {
        $state.go('application.users.detail', { id: id });
      },

      deactivate: function(item) {
        var self = $scope.themesDonation;

        if (!item.archived) {
          self.item = item;
          self.modal = $uibModal.open({
              templateUrl: 'views/application/views/themes/donation/modals/deactivate/deactivate.tpl.html',
              size: 'md',
              controller: 'ThemesDonationModalsDeactivateController',
              resolve: {
                  themeItem: function () {
                      return item;
                  }
              }
          })
          .result.then( function(item) {
            ApiService.textVariables.override.update(item).then(self.success.deactivate, self.error.deactivate);
          });
        }
      },

      success: {
        init: function(response) {},
        getDonationTheme: function(response) {
          var self = $scope.themesDonation,
              pagination = response.data.payload.pagination;

          self.model = self.proccess(response.data.payload.list);

          self.gridDefinition.isLoaded = true;
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: pagination.count});
          }, 10);
        },
        deactivate: function(response) {
          var self = $scope.themesDonation;
          self.getDonationTheme();
        }
      },

      error: {
        init: function(response) {},
        getDonationTheme: function(response) {
          $scope.themesDonation.notice.showErrorMessages(response.data.payload);
        },
        deactivate: function(response) {
          $scope.themesDonation.notice.showErrorMessages(response.data.payload);
        }
      },

      onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
        var self = $scope.themesDonation;
        self.gridState.updateGridState(newPage, pageSize);
        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if(sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }
        self.getDonationTheme();
      },

      onfilterTypedUpdate: function() {
        $scope.themesDonation.getDonationTheme();
      }

    };

    $scope.themesDonation.init();

}]);
